<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('preInvoice.pageTitle'),
            href: '/pre-invoices'
          },
          {
            text: $t('show'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div>
            <div class="row form-group">
              <div class="col-md-6">
                <form class="form-horizontal">
                  <fieldset>
                    <legend>{{ $t('preInvoice.studentInfo') }}</legend>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.cardNumber')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          type="text"
                          class="form-control-plaintext"
                          :value="show_data.card_number"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.studentName')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.full_name_en"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.sex')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.gender"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.dateOfBirth')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.date_of_birth"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.phone')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.phone"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.batch')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.promotion"
                        />
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div class="col-md-6">
                <form class="form-horizontal">
                  <fieldset>
                    <legend>{{ $t('preInvoice.academic') }}</legend>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.mainProgram')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.main_program ? show_data.main_program.acp_name_foreign : ''"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.subProgram')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.sub_program ? show_data.sub_program.acps_name_foreign : ''"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.level')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.grade ? show_data.grade.level.level_name_foreign : ''"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.year')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.year"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.semester')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.semester"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('preInvoice.gradeName')
                      }}</label>
                      <div class="col-md-9">
                        <input
                          readonly
                          class="form-control-plaintext"
                          :value="show_data.grade ?show_data.grade.grade_name_foreign : ''"
                        />
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <panel :title="$t('preInvoice.item')">
                  <div class="overflow-auto">
                    <div id="list-container">
                      <table
                        class="table ui-table ts-table"
                        style="min-width:1570px"
                      >
                        <thead>
                          <tr>
                            <th style="width:250px">
                              {{ $t('paymentNotice.feeType') }}
                            </th>
                            <th style="width:250px">
                              {{ $t('paymentNotice.feeName') }}
                            </th>
                            <th style="width:250px">
                              {{ $t('paymentNotice.description') }}
                            </th>                       
                            <th style="width:100px">
                              {{ $t('paymentNotice.startDate') }}
                            </th>                            
                            <th style="width:100px">
                              {{ $t('paymentNotice.endDate') }}
                            </th>
                            <th style="width:110px" class="text-center">
                              {{ $t('paymentNotice.qty') }}
                            </th>
                            <th style="width:110px" class="text-center">
                              {{ $t('paymentNotice.fee') }}
                            </th>
                            <th style="width:120px" class="text-center">
                              {{ $t('paymentNotice.discount') }}
                            </th>
                            <th style="width:110px" class="text-center">
                              {{ $t('paymentNotice.vat') }}
                            </th>
                            <th style="width:110px">
                              {{ $t('paymentNotice.amount') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item,
                            index) in show_data.pre_invoice_detail"
                            :key="index"
                          >
                            <td>{{ item.fee_type.fee_type_name }}</td>
                            <td>{{ item.fee_setup.fee_name_en }}</td>
                            <td>{{ item.fee_description }}</td>
                            <td>{{ item.fee_start_date }}</td>
                            <td>{{ item.fee_end_date }}</td>
                            <td class="text-center">{{ item.quantity }}</td>
                            <td class="text-center">{{ item.fee_amount }}</td>
                            <td class="text-center">
                              {{ item.discount_rate }}
                            </td>
                            <td class="text-center">{{ item.vat_rate }}</td>
                            <td class="text-right">{{ item.total_amount }}</td>
                          </tr>
                          <tr>
                            <td colspan="9" class="text-right">
                              <strong>{{ $t('preInvoice.total') }}</strong>
                            </td>
                            <td class="text-right">
                              <strong
                                ><u>{{ show_data.total_amount }}</u></strong
                              >
                            </td>
                          </tr>
                          <tr height="24"></tr>
                          <tr class="bb">
                            <td
                              colspan="10"
                              valign="top"
                              class="ts-text-right"
                              v-show="show_data.is_approved == '1'"
                            >
                              <div
                                style="width: 400px"
                                class="ts-float-right ts-space-y-3"
                              >
                                <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                                  <div
                                    class="ts-flex ts-items-center ts-justify-end"
                                  >
                                    <label
                                      >{{ $t('invoice.paymentMethod') }}
                                      <span class="text-danger">*</span></label
                                    >
                                  </div>
                                  <div class="ts-col-span-2 ts-pl-4">
                                    <select
                                      class="form-control"
                                      v-model="model.payment_method_id"
                                      :disabled="show_data.is_approved == 1"
                                    >
                                      <option value="">--select--</option>
                                      <option
                                        v-for="(p, index) in paymentMethods"
                                        :key="index"
                                        :value="p.id"
                                        >{{ p.label }}</option
                                      >
                                    </select>
                                    <div
                                      class="validate"
                                      v-if="
                                        errors.has('data.payment_method_id')
                                      "
                                    >
                                      {{
                                        errors.first('data.payment_method_id')
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="ts-grid ts-grid-cols-3 ts-gap-3"
                                  v-show="model.payment_method_id != 1"
                                >
                                  <div
                                    class="ts-flex ts-items-center ts-justify-end"
                                  >
                                    <label
                                      >{{ $t('invoice.bankName') }}
                                      <span
                                        class="text-danger"
                                        v-show="model.payment_method_id != 1"
                                        >*</span
                                      ></label
                                    >
                                  </div>
                                  <div class="ts-col-span-2 ts-pl-4">
                                    <select
                                      v-model="model.bank_id"
                                      class="form-control"
                                      :disabled="show_data.is_approved == 1"
                                    >
                                      <option
                                        v-for="(b, index) in banks"
                                        :value="b.bank_id"
                                        :key="index"
                                        >{{ b.bank_name }}</option
                                      >
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </panel>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <ts-button @click="$router.push({ name: 'pre-invoice' })">{{
                  $t('back')
                }}</ts-button>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import PdfPreview from '../../official-receipts/views/components/pdf_preview.vue'

export default {
  name: 'preInvoiceShow',
  components: { PdfPreview },
  data() {
    return {
      approving: false,
      loading: false,
      pdf_view: false,
      errors: new Errors(),
      model: {},
      invoiceId: 0,
      banks: [],
      show_data: {}
    }
  },
  computed: {
    paymentMethods() {
      return [
        { id: 1, label: 'Cash' },
        { id: 2, label: 'Cheque' },
        { id: 3, label: 'Bank Transfer' },
        { id: 4, label: 'Credit Card' }
      ]
    }
  },
  mounted() {
    this.setEditData()
    this.fetchBankProfile()
  },
  methods: {
    ...mapActions('paymentNoticeModule', ['onGetBank']),
    fetchBankProfile() {
      this.onGetBank().then(response => {
        this.banks = response.data.data
      })
    },
    async setEditData() {
      this.loading = true
      await this.$store
        .dispatch('paymentNoticeModule/onShowRecord', this.$route.params.id)
        .then(response => {
          this.show_data = response.data.data
          if (!_.isEmpty(this.show_data)) {
            this.errors = new Errors()
            this.model = {
              inv_id: this.show_data.inv_id,
              card_number: this.show_data.card_number,
              full_name_en: this.show_data.full_name_en,
              gender: this.show_data.gender,
              date_of_birth: this.show_data.date_of_birth,
              phone: this.show_data.phone,
              promotion: this.show_data.promotion,
              acp_id: this.show_data.acp_id,
              acps_id: this.show_data.acps_id,
              level_id: this.show_data.level_id,
              grade_id: this.show_data.grade_id,
              year: this.show_data.year,
              semester: this.show_data.semester,
              total_amount: this.show_data.total_amount,
              payment_method_id: this.show_data.payment_method_id,
              bank_id: this.show_data.bank_id,
              pre_invoice_detail: _.clone(this.show_data.pre_invoice_detail)
            }
          }
        })
        .finally(() => this.loading = false)
    },
    pushBack() {
      this.$router.push({ name: 'pre-invoice' })
    }
  }
}
</script>

<style lang="css" scoped>
#list-container {
  white-space: nowrap;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
